import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import SessionStorage from '@app/helpers/SessionStorage';
import { HeaderService } from '@app/services/header.service';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
import PhotoHelper from '@app/helpers/PhotoHelper';


@Component({
  selector: 'app-show-check-in-steps',
  templateUrl: './show-check-in-steps.component.html',
  styleUrls: ['./show-check-in-steps.component.scss']
})
export class ShowCheckInStepsComponent implements OnInit {
  queryParams: Params;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  needSelfie: boolean

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private headerService: HeaderService,
    public sessionstorageService: SessionstorageService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private chatService: ChatService,

  ) { }

  ngOnInit() {
    this.needSelfie = PhotoHelper.NeedSelfie();

    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params;
    })
    this.headerService.setNavigationVisibility(true);

    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })
  }

  startClick() {
    let guest = SessionStorage.SelectedGuestData
    SessionStorage.MrzData = undefined;
    SessionStorage.FaceImageFromCard = '';
    SessionStorage.Selfie = '';
    // this.router.navigateByUrl('/checkinstatus')

    this.router.navigateByUrl('/ageselection?GuestStayUuId=' + guest.GuestStayUuId)
  }


  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  openChat() {
    console.log(this.chatService.isWithin())
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }
}
